import * as React from 'react';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { useTurnstile } from '../hooks/useTurnstile';
import { ReactComponent as Loading } from '../assets/loading.svg';

interface TurnstileWidgetProps {
    fieldName: string;
    setValue: UseFormSetValue<any>;
    register: UseFormRegister<any>;
    sitekey?: string;
    containerId?: string;
    onLoadingChange?: (isLoading: boolean) => void;
    onErrorChange?: (error: string | null) => void;
}

export interface TurnstileWidgetRef {
    reset: () => void;
}

export const TurnstileWidget = React.forwardRef<TurnstileWidgetRef, TurnstileWidgetProps>(
    ({ fieldName, setValue, register, sitekey, containerId = 'cf-turnstile', onLoadingChange, onErrorChange }, ref) => {
        const { isLoading, error, resetCaptcha } = useTurnstile({
            fieldName,
            setValue,
            register,
            sitekey,
            containerId: `#${containerId}`,
            onLoadingChange,
            onErrorChange
        });

        // Expose reset method to parent component via ref
        React.useImperativeHandle(ref, () => ({
            reset: resetCaptcha
        }));

        const handleReload = () => {
            window.location.reload();
        };

        return (
            <div className="flex flex-col gap-2">
                <div className="cf-turnstile" id={containerId}></div>
                {isLoading && !error && (
                    <div className="flex items-center gap-2 text-tertiary text-12">
                        <Loading className="animate-spin fill-primary w-4 h-4" />
                        <span>Verificando se você é um humano...</span>
                    </div>
                )}
                {error && (
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2 text-red-500 text-12">
                            <svg className="w-4 h-4 fill-current flex-shrink-0" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            <span>{error}</span>
                        </div>
                        <button
                            type="button"
                            onClick={handleReload}
                            className="text-primary text-12 underline hover:no-underline self-start"
                        >
                            Recarregar página
                        </button>
                    </div>
                )}
            </div>
        );
    }
);

TurnstileWidget.displayName = 'TurnstileWidget';
